import { Link } from 'react-router'

import { Icon } from '@writefull/core'

import { Page } from '@ui/app/domain/page'
import Container from '@ui/shared/components/Container'

interface HomeProps {
  features: Page[]
}

export default function Home({ features }: HomeProps) {
  return (
    <div className='bg-white dark:bg-slate-700 theme-transition'>
      <Container className='grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-14 justify-center py-12'>
        {features.map((page) => (
          <Link to={page.path} key={page.name}>
            <div className='flow-root rounded-lg bg-gray-50 dark:bg-slate-800 px-6 pb-8 text-center theme-transition'>
              <div className='-mt-6'>
                <Icon
                  icon={page.icon}
                  size={6}
                  className='flex items-center justify-center p-3 bg-slate-800 dark:bg-slate-200 shadow-lg text-white dark:text-slate-800 rounded-md theme-transition'
                  aria-hidden='true'
                />
                <h3 className='mt-6 text-lg font-medium tracking-tight text-gray-900 dark:text-white theme-transition'>
                  {page.name}
                </h3>
                <p className='mt-3 text-base text-gray-500 dark:text-gray-400'>{page.title}</p>
              </div>
            </div>
          </Link>
        ))}
      </Container>
    </div>
  )
}
